'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _indexWeex = require('weex-bindingx/lib/index.weex.js');

var _indexWeex2 = _interopRequireDefault(_indexWeex);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

var _dofCell = require('../dof-cell');

var _dofCell2 = _interopRequireDefault(_dofCell);

var _dofSwitch = require('../dof-switch');

var _dofSwitch2 = _interopRequireDefault(_dofSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animation = weex.requireModule('animation'); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var modal = weex.requireModule('modal');
var dom = weex.requireModule('dom');
exports.default = {
  props: {
    listData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // styles: {
    //   type: Object,
    //   default: ()=>({})
    // }
    cellWidth: {
      type: Number,
      default: 0
    },
    padding: {
      type: Number,
      default: 0
    }
  },
  computed: {
    _cellWidth: function _cellWidth() {
      if (this.cellWidth) return this.cellWidth;
      if (this.padding) return 750 - this.padding;
      return 750;
    }
  },
  components: {
    DofCell: _dofCell2.default,
    DofSwitch: _dofSwitch2.default
  },
  data: function data() {
    return {
      mobileX: 0,
      webStarX: 0,
      saveIdx: null,
      isAndroid: _utils2.default.env.isAndroid(),
      isIOS: _utils2.default.env.isIOS(),

      cellCanClick: true, //android
      isHighlight: false
    };
  },
  mounted: function mounted() {},


  methods: {
    dofCellClicked: function dofCellClicked(index) {
      //点击触发滑动恢复初始化
      if (!this.isIOS) {
        this.rightSlide(); // 列表初始化
        this.cellCanClick && this.$emit('dofCellClicked', { index: index });
      } else {
        for (var _index = 0; _index < this.listData.length; _index++) {
          this.special(this.$refs.skid[_index], {
            transform: 'translate(0, 0)'
          });
        }
        this.$emit('dofCellClicked', { index: index });
      }
    },
    special: function special(dom, styles) {
      animation.transition(dom, {
        styles: styles,
        duration: 150, // ms
        timingFunction: 'ease',
        delay: 0 // ms
      });
    },
    onRightNode: function onRightNode(index, i, text) {
      if (!this.isIOS) {
        this.rightSlide();
        this.$emit('dofRightClicked', { index: index, i: i, text: text });
      } else {
        this.special(this.$refs.skid[this.saveIdx], {
          transform: 'translate(0, 0)'
        });
        this.$emit('dofRightClicked', { index: index, i: i, text: text });
      }
    },
    onPanEnd: function onPanEnd(e, node, i) {
      if (_utils2.default.env.isWeb()) {
        var webEndX = e.changedTouches[0].pageX;
        this.movingDistance(webEndX - this.webStarX, node, this.$refs.skid[i]);
      }
    },
    handleHorizontalpan: function handleHorizontalpan(e, item, index) {
      !this.isAndroid && this.onPanStart(e, item, index, item.rightItem ? item.rightItem.length : 0);
    },
    handlePanEnd: function handlePanEnd(e, item, index) {
      this.onPanEnd(e, item, index);
    },

    // 使用官方的pan事件解决某些ios设备使用@swipe不能滑动的问题
    onPanStart: function onPanStart(e, node, i, len) {
      var saveIdx = this.saveIdx;

      if (saveIdx !== i && saveIdx !== null && this.$refs.skid[saveIdx]) {
        this.special(this.$refs.skid[saveIdx], {
          transform: 'translate(0, 0)'
        });
        this.mobileX = 0;
      }
      this.saveIdx = i;
      this.mobile(e, node, i, len);
      // !Utils.env.isWeb() ? this.mobile(e, node, i, len) : this.web(e, node, i)
      // e.stopPropagation()
    },
    web: function web(e, node, i) {
      this.webStarX = e.changedTouches[0].pageX;
    },
    mobile: function mobile(e, node, i, len) {
      var _this = this;

      var el = this.$refs['skid'][i];
      _indexWeex2.default.bind({
        anchor: el.ref,
        eventType: 'pan',
        props: [{
          element: el.ref,
          property: 'transform.translateX',
          // expression: `x+${this.isAndroid ? 0 : this.mobileX}`
          expression: this.rightWidth(node) //处理ios设备左滑移动距离，防止闪烁
        }]
      }, function (e) {
        var state = e.state,
            deltaX = e.deltaX;

        if (state === 'end') {
          _this.mobileX = deltaX;
          // this.movingDistance(this.mobileX, node, el);
          _this.movingDistance(e.deltaX, node, el); //add by lau
        }
      });
    },
    movingDistance: function movingDistance(scope, node, el) {
      var len = node.rightItem ? node.rightItem.length : 0;
      var distance = -this.rightWidth(node);
      // if (scope < -80*len) {
      //   this.special(el, {
      //     transform: `translate(${distance}px, 0)`
      //   });
      //   this.mobileX = distance;
      // } else {
      //   this.special(el, {
      //     transform: 'translate(0, 0)'
      //   });
      //   this.mobileX = 0;
      // }

      //modify by lau
      if (scope < 0) {
        this.special(el, {
          transform: 'translate(' + distance + 'px, 0)'
        });
      } else if (scope > 0) {
        this.special(el, {
          transform: 'translate(0, 0)'
        });
      } else {
        return;
      }
    },


    // 适配Android
    // 经n次尝试和测试后，发现weex的click事件和touchend事件冲突, 防止滑动后触发click事件
    // 这里异步处理，touchend事件结束后才激活向上传递的click事件
    touchend: function touchend() {
      var _this2 = this;

      setTimeout(function () {
        _this2.cellCanClick = true;
      }, 100);
    },
    slideMenu: function slideMenu(e, index, item) {
      var length = item.rightItem.length;
      this.cellCanClick = false;
      var listItems = this.$refs.menuItem;
      var ele = this.$refs.menuItem[index];
      var direction = e.direction;
      if (direction == 'left') {
        this.leftSlide(e, ele, length, this.listData[index]);
      } else if (direction == 'right') {
        this.rightSlide(ele);
      }
      e.stopPropagation();
    },


    // @params ele 要执行动画的元素
    leftSlide: function leftSlide(e, ele, length, item) {
      this.rightSlide();
      animation.transition(ele, {
        styles: {
          transform: 'translateX(-' + this.rightWidth(item) + 'px)'
        },
        duration: 150, //ms
        timingFunction: 'ease',
        // needLayout: false,   //变化后是否刷新页面
        delay: 0 //ms
      });
      e.stopPropagation();
    },
    rightSlide: function rightSlide() {
      var listItems = this.$refs.menuItem;
      for (var i = 0; i < listItems.length; i++) {
        animation.transition(listItems[i], {
          styles: {
            transform: 'translateX(0px)'
          },
          duration: 100, //ms
          timingFunction: 'ease-in',
          needLayout: true,
          delay: 0 //ms
        }, function () {});
      }
      return false;
    },
    rightWidth: function rightWidth(item) {
      if (item.rightItem && item.rightItem.length) {
        return item.rightItem.reduce(function (pre, cur) {
          return pre + (cur.width || 160);
        }, 0);
      }
      return 0;
    },
    handleSwitchChange: function handleSwitchChange(item) {
      item.switchVal = !item.switchVal;
      this.$emit('switchChange', item);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-swipe-action/index.vue
// module id = 403
// module chunks = 0 1